import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  kind: 'primary' | 'secondary' | 'tertiary'
}

function SearchTilePrimaryActionButton({ kind }: Props) {
  const intl = useIntl()

  return <TextButton nonInteractable kind={kind}>{intl.formatMessage({
    id: 'YRe4Uc5wsd',
    defaultMessage: 'View offer',
    description: 'Button text to view offer details on search tile',
  })}
  </TextButton>
}

export default SearchTilePrimaryActionButton
